module.exports = __webpack_public_path__ + "static/media/techlogo.53b2dbb9.svg";